<template>
  <div class="clientCenter">
    <el-card class="labelStyle">
      <el-form>
        <el-form-item label="总部地址：">
          <CascaderArea
            :country="queryInfo.workIntro"
            :province="queryInfo.companyProvince"
            :city="queryInfo.companyCity"
            @searchArae="searchArae"
            class="CascaderArea"
          />
        </el-form-item>
        <el-form-item label="所属行业："
          ><multiSelect typeCode="004" @change="searchLabel" :code.sync="queryInfo.cilentIndustry"
        /></el-form-item>
        <el-form-item label="合作状态：">
          <radio-select :code.sync="queryInfo.cilentState" type-code="001" @onChange="onChange" />
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 20px">
      <div class="enterporise_list_input_add">
        <div class="input_new">
          <el-input
            placeholder="请输入客户相关信息"
            v-model="queryInfo.cilentName"
            class="input-with-select"
            clearable
          >
            <el-button
              slot="append"
              @click="
                search()
                resetPage()
              "
              icon="el-icon-search"
            ></el-button>
          </el-input>
        </div>
        <el-button type="primary" class="add_enterprise" @click="addClient()">+新增客户</el-button>
      </div>
      <el-table
        ref="multipleTable"
        class="enterprise_table"
        :data="clientTableData"
        style="width: 100%"
      >
        <el-table-column type="selection" width="55" align="center"> </el-table-column>
        <el-table-column label="序号" align="center" width="80">
          <template v-slot="scope">
            <span>
              {{ queryInfo.baseParam.pageNum * queryInfo.baseParam.pageSize + (scope.$index + 1) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column width="100" label="Logo" align="center">
          <template v-slot="{ row }">
            <el-image
              @click="editItem(row)"
              :src="row.cilentLogoKey"
              v-if="row.cilentLogoKey"
              style="cursor: pointer"
            ></el-image>
            <el-image :src="pro" style="cursor: pointer" v-else></el-image>
          </template>
        </el-table-column>
        <el-table-column label="公司名称" align="center" prop="cientName"></el-table-column>
        <el-table-column label="总部地址" align="center" prop="workIntro">
          <template slot-scope="scope">
            {{ scope.row.workIntro ? scope.row.workIntro : '' }}
            {{ scope.row.companyProvince ? scope.row.companyProvince : '' }}
            {{ scope.row.companyCity ? scope.row.companyCity : '' }}
          </template>
        </el-table-column>
        <el-table-column
          label="所属行业"
          align="center"
          prop="cilentIndustry"
          width="150"
        ></el-table-column>
        <el-table-column label="企业性质" align="center" prop="cilentNature"></el-table-column>
        <el-table-column label="企业规模" align="center" prop="cilentScale"></el-table-column>
        <el-table-column
          label="融资轮次"
          align="center"
          prop="cilentFinancing"
          width="100"
        ></el-table-column>
        <el-table-column
          label="合作状态"
          align="center"
          prop="cilentState"
          width="80"
        ></el-table-column>
        <el-table-column label="客户经理" align="center" prop="cilentManagerName"></el-table-column>
        <el-table-column class="operation" width="100" label="操作" align="center">
          <template v-slot="{ row }">
            <div class="operation_bottom">
              <dic-button @buttonClick="editItem(row)" icon="icon-jr-icon-modify" text="编辑" />
              <dic-button @buttonClick="deleteItem(row)" icon="icon-jr-icon-delete" text="删除" />
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page_nation">
        <el-pagination
          :current-page="queryInfo.pageNum"
          :page-sizes="[30, 50, 100]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import CascaderArea from '@/components/CascaderArea.vue'
import radioSelect from '@/components/RadioSelect.vue'
import { getCilent, deleteCilent } from '@/api/cutsomer.js'
import multiSelect from '@/components/MultiSelect.vue'

import DicButton from '@/components/DicButton.vue'
import pro from '../../../../static/images/pro.png'
const defaultQueryObj = Object.freeze({
  cilentName: '', //客户名称
  cilentIndustry: [], //客户所属行业
  cilentState: '', //客户公司合作状态
  companyCity: '', //客户所属城市
  companyProvince: '', //客户所属省份
  workIntro: '中国', //客户所在地区
  order: '', //排序
  baseParam: {
    pageNum: 1, //页数
    pageSize: 30 //大小
  },
  size: '' //所选条数
})
export default {
  components: {
    multiSelect,
    CascaderArea,
    radioSelect,
    DicButton
  },
  created() {
    // if (Object.keys(this.$store.state.queryInfo).length) {
    //   Object.keys(this.$store.state.queryInfo).forEach((item) => {
    //     this.queryInfo[item] = this.$store.state.queryInfo[item]
    //   })
    // }
    this.search()
  },
  data() {
    return {
      queryInfo: { ...defaultQueryObj },
      clientTableData: [],
      pro,
      total: null
    }
  },
  methods: {
    searchLabel(data) {
      this.resetPage()
      this.queryInfo.cilentIndustry = data
      this.search()
    },
    async search() {
      const res = await getCilent(this.queryInfo)
      if (res.data.resultCode == 200) {
        this.clientTableData = res.data.data.list
        this.total = res.data.data.total
      }
    },
    // 添加
    addClient() {
      this.$router.push({
        name: 'CustomerCenterInfo',
        query: {
          searchInfo: JSON.stringify(this.queryInfo)
        }
      })
    },
    // 修改
    editItem(row) {
      this.$router.push({
        name: 'CustomerCenterInfo',
        query: {
          id: row.clientCode,
          clientType: 1,
          searchInfo: JSON.stringify(this.queryInfo)
        }
      })
    },
    // 删除
    deleteItem(row) {
      this.$confirm('确认删除吗 ?', '提示')
        .then(async () => {
          const { data: res } = await deleteCilent({ clientCode: row.clientCode })
          if (res.resultCode == 200) {
            this.$message.success('删除成功')
            this.search()
          }
        })
        .catch(() => {})
    },
    searchArae(val) {
      this.queryInfo.workIntro = val.country

      this.queryInfo.companyProvince = val.province

      if (val.city != '北京' && val.city != '天津' && val.city != '上海' && val.city != '重庆') {
        this.queryInfo.companyCity = val.city
      }
      this.resetPage()

      this.search()
    },
    onChange() {
      this.resetPage()

      this.search()
    },
    // 条数
    handleSizeChange(newSize) {
      this.queryInfo.baseParam.pageSize = newSize

      this.search()
    },

    // 分页
    handleCurrentChange(newPage) {
      this.queryInfo.baseParam.pageNum = newPage

      this.search()
    },
    resetPage() {
      this.queryInfo.baseParam.pageNum = 1
      this.queryInfo.baseParam.pageSize = 30
    }
  }
}
</script>

<style lang="less" scoped>
.clientCenter {
  .el-table {
    /deep/tbody tr:hover > td {
      // background-color: #90c0f1;
      background-color: rgba(23, 117, 122, 0.1);
    }
  }
  /deep/ .el-form-item {
    margin-bottom: 5px;
  }
  .page_nation {
    width: 100%;
    margin: 40px auto 0 auto;
    text-align: center;
  }
  .enterporise_list_input_add {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    /deep/ .input-with-select {
      width: 320px;
      margin-right: 50px;
    }
    .input_new {
      /deep/ .el-button {
        border-radius: 0 4px 4px 0;
        height: 40px;
      }

      /deep/ .el-button--default {
        background-color: #17757a;

        i {
          color: #fff;
        }
      }
    }

    .add_enterprise {
      background-color: #17757a;
      border-color: #17757a;
    }
  }
  .enterprise_table {
    margin-top: 20px;
    width: 100%;
    .el_image {
      width: 48px;
      height: 48px;
      border-radius: 4px;
    }
  }
  .operation_bottom {
    .operation_border {
      font-size: 18px;
      color: #e8e8e8;
    }
  }
  .CascaderArea {
    /deep/ .el-input__inner {
      border: 1px solid #17757a;
      color: #17757a;
      height: 34px;
      line-height: 34px;
    }
  }
  /deep/ .el-image__inner {
    border-radius: 5px;
  }
}
</style>
